(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-generic"]) return;
  try {
    
  if (!customElements.get('physical-product')) {
    customElements.define('physical-product', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.select = this.querySelector('[data-variant-select]');
        this.quantity = this.querySelector('[data-quantity]');
        this.submit = this.querySelector('[data-submit]');
        this.track = this.querySelector('[data-track]');
        this.thumbnails = this.querySelector('[data-thumbnails]');
        if (!this.select || !this.quantity || !this.submit) return;
        this.skuPicker = this.querySelector('[data-sku-picker]');
        if (this.skuPicker) {
          this.select.hidden = true;
          this.skuPicker.hidden = false;
          const label = this.querySelector('label[for="' + this.select.id + '"]');
          if (label) {
            label.id = this.select.id + '-label';
            this.skuPicker.setAttribute('aria-labelledby', label.id);
          }
          this.skuPicker.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
              this.skuPicker.open = false;
              this.skuPicker.querySelector('summary').focus();
            }
            if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
              event.preventDefault();
              this.skuPicker.open = true;
              const options = Array.from(this.skuPicker.querySelectorAll('button:not(:disabled)'));
              const current = options.indexOf(document.activeElement);
              const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : (current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
              options[next]?.focus();
            }
          }, { signal: this.abort.signal });
          document.addEventListener('click', event => {
            if (!this.skuPicker.contains(event.target)) this.skuPicker.open = false;
          }, { signal: this.abort.signal });
          this.skuPicker.addEventListener('focusout', event => {
            if (!this.skuPicker.contains(event.relatedTarget)) this.skuPicker.open = false;
          }, { signal: this.abort.signal });
        }
        this.setAttribute('data-enhanced', '');
        this.setupMobileLayout();
        this.querySelectorAll('[data-quantity-step], [data-gallery-controls]').forEach(el => el.hidden = false);
        this.addEventListener('change', event => {
          if (event.target === this.select) this.updateVariant(true);
        }, { signal: this.abort.signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.dataset.skuValue && !button.disabled) {
            this.select.value = button.dataset.skuValue;
            this.select.dispatchEvent(new Event('change', { bubbles: true }));
            this.skuPicker.open = false;
            this.skuPicker.querySelector('summary').focus();
          }
          if (button.dataset.quantityStep) {
            const min = Number(this.quantity.min) || 1, step = Number(this.quantity.step) || 1;
            const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
            const value = Number(this.quantity.value) || min;
            this.quantity.value = String(Math.max(min, Math.min(max, value + Number(button.dataset.quantityStep) * step)));
            this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (button.dataset.mediaTarget) this.showMedia(button.dataset.mediaTarget);
          if (button.dataset.thumbnailStep && this.thumbnails) {
            this.thumbnails.scrollBy({ top: Number(button.dataset.thumbnailStep) * this.thumbnails.clientHeight * .8, behavior: 'auto' });
            this.updateThumbnailControls();
          }
          if (button.dataset.galleryStep && this.track) {
            const slides = Array.from(this.track.children);
            const current = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
            const next = (current + Number(button.dataset.galleryStep) + slides.length) % slides.length;
            if (slides[next]) this.showMedia(slides[next].dataset.mediaId);
          }
          if (button.hasAttribute('data-tray-submit') && !this.submit.disabled) this.submit.form.requestSubmit(this.submit);
        }, { signal: this.abort.signal });
        this.track?.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.syncGallery(), 100);
        }, { passive: true, signal: this.abort.signal });
        this.updateVariant(false);
        this.thumbnails?.addEventListener('scroll', () => this.updateThumbnailControls(), { passive: true, signal: this.abort.signal });
        if (this.track && 'ResizeObserver' in window) {
          this.galleryObserver = new ResizeObserver(() => {
            this.querySelector('.physical-product__gallery').style.setProperty('--gallery-height', this.track.getBoundingClientRect().height + 'px');
            this.updateThumbnailControls();
            const active = this.querySelector('[data-media-target][aria-pressed="true"]');
            if (active) this.showMedia(active.dataset.mediaTarget);
          });
          this.galleryObserver.observe(this.track);
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            const tray = this.querySelector('[data-tray]');
            if (tray) tray.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom >= 0;
          });
          this.observer.observe(this.submit);
        }
      }
      setupMobileLayout() {
        const title = this.querySelector('.physical-product__purchase > h1');
        const gallery = this.querySelector('.physical-product__gallery');
        const description = this.querySelector('.physical-product__short-description');
        const quantityRow = this.querySelector('.physical-product__quantity-row');
        if (!title || !gallery || !window.matchMedia) return;
        if (!this.mobileLayout) {
          const titleHome = document.createTextNode('');
          title.before(titleHome);
          const descriptionHome = document.createTextNode('');
          description?.before(descriptionHome);
          this.mobileLayout = () => {
            if (this.mobileQuery.matches) {
              gallery.before(title);
              if (description && quantityRow) quantityRow.after(description);
            } else {
              titleHome.after(title);
              if (description) descriptionHome.after(description);
            }
          };
        }
        this.mobileQuery = window.matchMedia('(max-width: 59.99rem)');
        this.mobileQuery.addEventListener('change', this.mobileLayout, { signal: this.abort.signal });
        this.mobileLayout();
      }
      updateVariant(updateUrl) {
        const option = this.select.options[this.select.selectedIndex];
        if (!option) return;
        const data = option.dataset, available = data.available === 'true';
        if (this.skuPicker) {
          this.skuPicker.querySelector('[data-sku-name]').textContent = data.label || option.textContent;
          this.skuPicker.querySelector('[data-sku-price]').textContent = data.price;
          this.skuPicker.querySelectorAll('[data-sku-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.skuValue === option.value)));
        }
        this.querySelectorAll('span[data-price]').forEach(el => el.textContent = data.price);
        const compare = this.querySelector('s[data-compare]');
        if (compare) { compare.textContent = data.compare || ''; compare.hidden = !data.compare; }
        const unit = this.querySelector('p[data-unit], span[data-unit]');
        if (unit) { unit.textContent = data.unit || ''; unit.hidden = !data.unit; }
        this.querySelector('[data-stock]').textContent = available ? this.dataset.availableLabel : this.dataset.soldLabel;
        this.querySelectorAll('[data-submit], [data-tray-submit]').forEach(el => {
          el.disabled = !available; el.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        });
        const payment = this.querySelector('[data-payment]');
        if (payment) payment.hidden = !available;
        const min = Number(data.min) || 1, step = Number(data.step) || 1;
        this.quantity.min = String(min); this.quantity.step = String(step);
        if (data.max) this.quantity.max = data.max; else this.quantity.removeAttribute('max');
        const value = Math.max(min, Number(this.quantity.value) || min);
        this.quantity.value = String(Math.min(data.max ? Number(data.max) : Infinity, min + Math.ceil((value - min) / step) * step));
        if (data.media) this.showMedia(data.media);
        if (updateUrl) {
          const url = new URL(location.href); url.searchParams.set('variant', option.value);
          history.replaceState(history.state, '', url);
        }
      }
      showMedia(id) {
        if (!this.track) return;
        const slides = Array.from(this.track.children);
        const index = slides.findIndex(el => el.dataset.mediaId === String(id));
        if (index < 0) return;
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'auto' });
        this.syncGallery(index);
      }
      syncGallery(selectedIndex) {
        if (!this.track) return;
        const slides = Array.from(this.track.children);
        const index = selectedIndex ?? Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
        const current = slides[Math.max(0, Math.min(index, slides.length - 1))];
        if (!current) return;
        this.querySelectorAll('[data-media-target]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mediaTarget === current.dataset.mediaId)));
        const active = this.querySelector('[data-media-target][aria-pressed="true"]');
        if (active && this.thumbnails) {
          const outer = this.thumbnails.getBoundingClientRect(), inner = active.getBoundingClientRect();
          const horizontal = getComputedStyle(this.thumbnails).flexDirection === 'row';
          const offset = horizontal ? (inner.left < outer.left ? inner.left - outer.left : Math.max(0, inner.right - outer.right)) : (inner.top < outer.top ? inner.top - outer.top : Math.max(0, inner.bottom - outer.bottom));
          if (offset) this.thumbnails.scrollBy(horizontal ? { left: offset, behavior: 'auto' } : { top: offset, behavior: 'auto' });
          this.updateThumbnailControls();
        }
        const status = this.querySelector('[data-gallery-status]');
        if (status) status.textContent = `${index + 1} / ${slides.length}`;
        slides.filter(el => el !== current).forEach(el => el.querySelectorAll('video').forEach(video => video.pause()));
      }
      updateThumbnailControls() {
        if (!this.thumbnails) return;
        const vertical = getComputedStyle(this.thumbnails).flexDirection === 'column';
        const nav = this.thumbnails.parentElement;
        const contentHeight = this.thumbnails.scrollHeight;
        const overflow = vertical && contentHeight > nav.clientHeight + 1;
        this.querySelectorAll('[data-thumbnail-step]').forEach(button => {
          button.hidden = !overflow;
          button.disabled = Number(button.dataset.thumbnailStep) < 0 ? this.thumbnails.scrollTop <= 1 : this.thumbnails.scrollTop + this.thumbnails.clientHeight >= contentHeight - 1;
        });
      }
      disconnectedCallback() {
        this.galleryObserver?.disconnect();
        this.abort?.abort(); this.abort = null; this.observer?.disconnect(); clearTimeout(this.scrollTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
